// Full list of world countries with ISO code + dial code.
// Flag emoji is derived from the ISO2 code (regional indicator symbols).

const RAW = [
  ["AF", "Afghanistan", "+93"], ["AL", "Albania", "+355"], ["DZ", "Algeria", "+213"],
  ["AS", "American Samoa", "+1"], ["AD", "Andorra", "+376"], ["AO", "Angola", "+244"],
  ["AI", "Anguilla", "+1"], ["AG", "Antigua and Barbuda", "+1"], ["AR", "Argentina", "+54"],
  ["AM", "Armenia", "+374"], ["AW", "Aruba", "+297"], ["AU", "Australia", "+61"],
  ["AT", "Austria", "+43"], ["AZ", "Azerbaijan", "+994"], ["BS", "Bahamas", "+1"],
  ["BH", "Bahrain", "+973"], ["BD", "Bangladesh", "+880"], ["BB", "Barbados", "+1"],
  ["BY", "Belarus", "+375"], ["BE", "Belgium", "+32"], ["BZ", "Belize", "+501"],
  ["BJ", "Benin", "+229"], ["BM", "Bermuda", "+1"], ["BT", "Bhutan", "+975"],
  ["BO", "Bolivia", "+591"], ["BA", "Bosnia and Herzegovina", "+387"], ["BW", "Botswana", "+267"],
  ["BR", "Brazil", "+55"], ["BN", "Brunei", "+673"], ["BG", "Bulgaria", "+359"],
  ["BF", "Burkina Faso", "+226"], ["BI", "Burundi", "+257"], ["KH", "Cambodia", "+855"],
  ["CM", "Cameroon", "+237"], ["CA", "Canada", "+1"], ["CV", "Cape Verde", "+238"],
  ["KY", "Cayman Islands", "+1"], ["CF", "Central African Republic", "+236"], ["TD", "Chad", "+235"],
  ["CL", "Chile", "+56"], ["CN", "China", "+86"], ["CO", "Colombia", "+57"],
  ["KM", "Comoros", "+269"], ["CG", "Congo", "+242"], ["CD", "DR Congo", "+243"],
  ["CR", "Costa Rica", "+506"], ["CI", "Côte d'Ivoire", "+225"], ["HR", "Croatia", "+385"],
  ["CU", "Cuba", "+53"], ["CY", "Cyprus", "+357"], ["CZ", "Czech Republic", "+420"],
  ["DK", "Denmark", "+45"], ["DJ", "Djibouti", "+253"], ["DM", "Dominica", "+1"],
  ["DO", "Dominican Republic", "+1"], ["EC", "Ecuador", "+593"], ["EG", "Egypt", "+20"],
  ["SV", "El Salvador", "+503"], ["GQ", "Equatorial Guinea", "+240"], ["ER", "Eritrea", "+291"],
  ["EE", "Estonia", "+372"], ["SZ", "Eswatini", "+268"], ["ET", "Ethiopia", "+251"],
  ["FJ", "Fiji", "+679"], ["FI", "Finland", "+358"], ["FR", "France", "+33"],
  ["GF", "French Guiana", "+594"], ["PF", "French Polynesia", "+689"], ["GA", "Gabon", "+241"],
  ["GM", "Gambia", "+220"], ["GE", "Georgia", "+995"], ["DE", "Germany", "+49"],
  ["GH", "Ghana", "+233"], ["GI", "Gibraltar", "+350"], ["GR", "Greece", "+30"],
  ["GL", "Greenland", "+299"], ["GD", "Grenada", "+1"], ["GP", "Guadeloupe", "+590"],
  ["GU", "Guam", "+1"], ["GT", "Guatemala", "+502"], ["GN", "Guinea", "+224"],
  ["GW", "Guinea-Bissau", "+245"], ["GY", "Guyana", "+592"], ["HT", "Haiti", "+509"],
  ["HN", "Honduras", "+504"], ["HK", "Hong Kong", "+852"], ["HU", "Hungary", "+36"],
  ["IS", "Iceland", "+354"], ["IN", "India", "+91"], ["ID", "Indonesia", "+62"],
  ["IR", "Iran", "+98"], ["IQ", "Iraq", "+964"], ["IE", "Ireland", "+353"],
  ["IL", "Israel", "+972"], ["IT", "Italy", "+39"], ["JM", "Jamaica", "+1"],
  ["JP", "Japan", "+81"], ["JO", "Jordan", "+962"], ["KZ", "Kazakhstan", "+7"],
  ["KE", "Kenya", "+254"], ["KI", "Kiribati", "+686"], ["KW", "Kuwait", "+965"],
  ["KG", "Kyrgyzstan", "+996"], ["LA", "Laos", "+856"], ["LV", "Latvia", "+371"],
  ["LB", "Lebanon", "+961"], ["LS", "Lesotho", "+266"], ["LR", "Liberia", "+231"],
  ["LY", "Libya", "+218"], ["LI", "Liechtenstein", "+423"], ["LT", "Lithuania", "+370"],
  ["LU", "Luxembourg", "+352"], ["MO", "Macau", "+853"], ["MG", "Madagascar", "+261"],
  ["MW", "Malawi", "+265"], ["MY", "Malaysia", "+60"], ["MV", "Maldives", "+960"],
  ["ML", "Mali", "+223"], ["MT", "Malta", "+356"], ["MH", "Marshall Islands", "+692"],
  ["MQ", "Martinique", "+596"], ["MR", "Mauritania", "+222"], ["MU", "Mauritius", "+230"],
  ["YT", "Mayotte", "+262"], ["MX", "Mexico", "+52"], ["FM", "Micronesia", "+691"],
  ["MD", "Moldova", "+373"], ["MC", "Monaco", "+377"], ["MN", "Mongolia", "+976"],
  ["ME", "Montenegro", "+382"], ["MS", "Montserrat", "+1"], ["MA", "Morocco", "+212"],
  ["MZ", "Mozambique", "+258"], ["MM", "Myanmar", "+95"], ["NA", "Namibia", "+264"],
  ["NR", "Nauru", "+674"], ["NP", "Nepal", "+977"], ["NL", "Netherlands", "+31"],
  ["NC", "New Caledonia", "+687"], ["NZ", "New Zealand", "+64"], ["NI", "Nicaragua", "+505"],
  ["NE", "Niger", "+227"], ["NG", "Nigeria", "+234"], ["KP", "North Korea", "+850"],
  ["MK", "North Macedonia", "+389"], ["NO", "Norway", "+47"], ["OM", "Oman", "+968"],
  ["PK", "Pakistan", "+92"], ["PW", "Palau", "+680"], ["PS", "Palestine", "+970"],
  ["PA", "Panama", "+507"], ["PG", "Papua New Guinea", "+675"], ["PY", "Paraguay", "+595"],
  ["PE", "Peru", "+51"], ["PH", "Philippines", "+63"], ["PL", "Poland", "+48"],
  ["PT", "Portugal", "+351"], ["PR", "Puerto Rico", "+1"], ["QA", "Qatar", "+974"],
  ["RE", "Réunion", "+262"], ["RO", "Romania", "+40"], ["RU", "Russia", "+7"],
  ["RW", "Rwanda", "+250"], ["KN", "Saint Kitts and Nevis", "+1"], ["LC", "Saint Lucia", "+1"],
  ["VC", "Saint Vincent and the Grenadines", "+1"], ["WS", "Samoa", "+685"], ["SM", "San Marino", "+378"],
  ["ST", "São Tomé and Príncipe", "+239"], ["SA", "Saudi Arabia", "+966"], ["SN", "Senegal", "+221"],
  ["RS", "Serbia", "+381"], ["SC", "Seychelles", "+248"], ["SL", "Sierra Leone", "+232"],
  ["SG", "Singapore", "+65"], ["SK", "Slovakia", "+421"], ["SI", "Slovenia", "+386"],
  ["SB", "Solomon Islands", "+677"], ["SO", "Somalia", "+252"], ["ZA", "South Africa", "+27"],
  ["KR", "South Korea", "+82"], ["SS", "South Sudan", "+211"], ["ES", "Spain", "+34"],
  ["LK", "Sri Lanka", "+94"], ["SD", "Sudan", "+249"], ["SR", "Suriname", "+597"],
  ["SE", "Sweden", "+46"], ["CH", "Switzerland", "+41"], ["SY", "Syria", "+963"],
  ["TW", "Taiwan", "+886"], ["TJ", "Tajikistan", "+992"], ["TZ", "Tanzania", "+255"],
  ["TH", "Thailand", "+66"], ["TL", "Timor-Leste", "+670"], ["TG", "Togo", "+228"],
  ["TO", "Tonga", "+676"], ["TT", "Trinidad and Tobago", "+1"], ["TN", "Tunisia", "+216"],
  ["TR", "Turkey", "+90"], ["TM", "Turkmenistan", "+993"], ["TC", "Turks and Caicos Islands", "+1"],
  ["TV", "Tuvalu", "+688"], ["UG", "Uganda", "+256"], ["UA", "Ukraine", "+380"],
  ["AE", "United Arab Emirates", "+971"], ["GB", "United Kingdom", "+44"], ["US", "United States", "+1"],
  ["UY", "Uruguay", "+598"], ["UZ", "Uzbekistan", "+998"], ["VU", "Vanuatu", "+678"],
  ["VA", "Vatican City", "+39"], ["VE", "Venezuela", "+58"], ["VN", "Vietnam", "+84"],
  ["VG", "British Virgin Islands", "+1"], ["VI", "U.S. Virgin Islands", "+1"], ["YE", "Yemen", "+967"],
  ["ZM", "Zambia", "+260"], ["ZW", "Zimbabwe", "+263"],
];

// Regional-indicator flag emoji from an ISO2 code.
export const flagEmoji = (code) =>
  code.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export const COUNTRIES = RAW
  .map(([code, name, dial]) => ({ code, name, dial, flag: flagEmoji(code) }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const findCountry = (code) => COUNTRIES.find((c) => c.code === code);
export const findByDial = (dial) => COUNTRIES.find((c) => c.dial === dial);

// Per-country national number grouping (array of digit-group lengths).
// Falls back to groups of 3 for anything not listed.
const MASKS = {
  US: [3, 3, 4], CA: [3, 3, 4], PR: [3, 3, 4], JM: [3, 3, 4], DO: [3, 3, 4], TT: [3, 3, 4],
  BS: [3, 3, 4], BB: [3, 3, 4], GB: [4, 3, 4], FR: [1, 2, 2, 2, 2], BE: [3, 2, 2, 2],
  DE: [4, 3, 4], ES: [3, 3, 3], IT: [3, 3, 4], PT: [3, 3, 3], NL: [1, 2, 3, 3],
  CH: [2, 3, 2, 2], IE: [2, 3, 4], RW: [3, 3, 3], CD: [2, 3, 4], CG: [2, 3, 4],
  SN: [2, 3, 2, 2], CI: [2, 2, 2, 2, 2], GH: [2, 3, 4], NG: [3, 3, 4], KE: [3, 3, 3],
  CM: [1, 4, 4], MA: [3, 3, 3], DZ: [3, 2, 2, 2], TN: [2, 3, 3], ZA: [2, 3, 4],
  IN: [5, 5], BR: [2, 5, 4], CN: [3, 4, 4], JP: [2, 4, 4], KR: [2, 4, 4],
  AE: [2, 3, 4], SA: [2, 3, 4], EG: [3, 3, 4], RU: [3, 3, 2, 2], UA: [2, 3, 2, 2],
  AU: [3, 3, 3], NZ: [2, 3, 4], MX: [3, 3, 4], AR: [2, 4, 4], CO: [3, 3, 4],
  ML: [2, 2, 2, 2], BF: [2, 2, 2, 2], BJ: [2, 2, 2, 2], TG: [2, 2, 2, 2], GN: [3, 3, 3],
  TZ: [3, 3, 3], UG: [3, 3, 3], ZM: [3, 3, 3], ZW: [3, 3, 3], AO: [3, 3, 3], MZ: [2, 3, 4],
  BW: [2, 3, 3], MW: [3, 3, 3], MU: [4, 4], ET: [2, 3, 4], ER: [1, 3, 3], LR: [2, 3, 3],
  SL: [2, 3, 4], GM: [3, 4], SO: [2, 3, 3], GA: [1, 2, 2, 2], CG2: [2, 3, 4], BI: [2, 2, 2, 2],
  RE: [3, 2, 2, 2], YT: [3, 2, 2, 2], NE: [2, 2, 2, 2], MR: [2, 2, 2, 2], TD: [2, 2, 2, 2],
};

export const maskFor = (code) => MASKS[code] || [3, 3, 3, 3];
export const maxDigits = (code) => maskFor(code).reduce((a, b) => a + b, 0);

// Format a raw digit string into the national grouping for a country.
export const formatNational = (raw, code) => {
  const groups = maskFor(code);
  const digits = (raw || "").replace(/\D/g, "").slice(0, maxDigits(code));
  const out = [];
  let i = 0;
  for (const g of groups) {
    if (i >= digits.length) break;
    out.push(digits.slice(i, i + g));
    i += g;
  }
  return out.join(" ");
};

// Preset SVG-ish emoji avatars (gold/silver on themed circles)
export const PRESET_AVATARS = [
  { id: "crown", icon: "👑", bg: "#1A1A1A", ring: "#D4AF37" },
  { id: "star", icon: "⭐", bg: "#2A2440", ring: "#D4AF37" },
  { id: "diamond", icon: "🔶", bg: "#3A2A46", ring: "#D4AF37" },
  { id: "heart", icon: "💛", bg: "#123833", ring: "#D4AF37" },
  { id: "shield", icon: "🛡️", bg: "#3A1F24", ring: "#D4AF37" },
  { id: "sun", icon: "☀️", bg: "#0F2544", ring: "#C0C0C0" },
  { id: "play", icon: "🔺", bg: "#2A1436", ring: "#D4AF37" },
  { id: "moon", icon: "🌙", bg: "#12251A", ring: "#D4AF37" },
  { id: "flower", icon: "🌼", bg: "#2A2410", ring: "#D4AF37" },
  { id: "bolt", icon: "⚡", bg: "#241040", ring: "#D4AF37" },
  { id: "gem", icon: "🔷", bg: "#0F2A44", ring: "#C0C0C0" },
  { id: "music", icon: "🎵", bg: "#3A1024", ring: "#D4AF37" },
];

export const avatarDataUrl = (preset) => {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='128' height='128'>
    <rect width='128' height='128' rx='64' fill='${preset.bg}'/>
    <rect x='3' y='3' width='122' height='122' rx='61' fill='none' stroke='${preset.ring}' stroke-width='3'/>
    <text x='64' y='84' font-size='58' text-anchor='middle'>${preset.icon}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
